import { App } from 'vue'

import Layout from './Layout.vue'
import Header from './Header.vue'
import Footer from './Footer.vue'
export function registerGlobalComponents(app: App) {
  app.component('Layout' , Layout),
  app.component('Header' , Header),
  app.component('Footer' , Footer)
}